import React, { Component } from "react";
import "./style/style.css";
import { RightChevron, ReportSvg, FolderIcon, CloseReportIcon } from "../../../../lib/icons";
import { OverlayTrigger, Tooltip, Popover } from "react-bootstrap";
import moment from "moment";
import PowerBIFolder from "../../../../components/tabsApps/components/powerBIFolder";
import { isRouteMatch } from "../../../../lib/reportingNavigation";

export class TopLevelNavItem extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      collapsed: false,
    };
  }
  handleClick(e, type, workspace, report) {
    if (type === "folder") {
      e.stopPropagation();
      e.preventDefault();
      this.setState((prevState) => ({
        collapsed: !prevState.collapsed,
      }));
    } else {
      if (report === undefined) {
        this.props.clickHandler(this.props, [this.props.parentIndex, this.props.index], this.props.type);
      } else {
        report.workspaceId = workspace;
        this.props.clickHandler(report, [this.props.parentIndex, this.props.index], type);
      }
    }
  }
  renderCollapsible() {
    return (
      <div className="menu-list-collapse">
        <RightChevron
          transform={this.state.collapsed ? "" : "rotate(90,12,12)"}
          height={"20px"}
          // width={"24px"}
          color={"rgba(88, 89, 91, 1)"}
          viewBox={"-1 2 24 24"}
        />
      </div>
    );
  }
  itemIcon(type) {
    switch (type) {
      case "powerBI":
        return <ReportSvg height={"16px"} className={"ta-pbi-icon"} color={"rgba(121, 121, 121, 1)"} viewBox={"0 -1 24 24"} />;
      case "tableau":
        return <ReportSvg height={"16px"} className={"ta-pbi-icon"} color={"rgba(121, 121, 121, 1)"} viewBox={"0 -1 24 24"} />;
      case "Files":
        return (
          <FolderIcon
            height={"12px"}
            className={"ta-pbi-icon"}
            color={"rgba(121, 121, 121, 1)"}
            style={{ marginBottom: "4px" }}
          />
        );
      default:
        return "";
    }
  }
  render() {
    const routeSelection = this.props.routeSelection || {};
    if (this.props.fileType === "folder" || this.props.type === "grouping") {
      return (
        <PowerBIFolder
          clickReportHandler={(e, workspace, report) => {
            e.stopPropagation();
            e.preventDefault();
            this.handleClick(e, report.type, workspace, report);
          }}
          key={this.props.index}
          report={this.props.tab.children[this.props.index]}
          routeSelection={routeSelection}
          openKeys={this.props.openKeys}
          wsStack={this.props.wsStack}
          workspace={this.props.tab.workspaceId}
          removeHandler={this.props.removeHandler}
          leftSideCaret={true}
          dontShowDates={true}
        />
      );
    } else {
      const routeMatchNode = {
        id: this.props.id,
        _id: this.props.reportTestId,
        rptId: this.props.reportTestId,
        path: this.props.path,
      };
      const active = isRouteMatch(routeMatchNode, routeSelection);
      const isOpen = this.props.isOpen;
      const canClose = active || isOpen;
      const reportTestId = this.props.reportTestId ? `nav-report-${this.props.reportTestId}` : undefined;
      let stateClass = "tab-unselected";
      if (active) {
        stateClass = "tab-selected";
      } else if (isOpen) {
        stateClass = "tab-open";
      }
      const node = this.props.node || {};
      const tipId = `nav-report-tip-${this.props.index}`;
      return (
        <OverlayTrigger
          key={tipId}
          placement={"top"}
          rootClose={true}
          trigger={["hover", "focus"]}
          overlay={
            <Popover id={tipId}>
              <Popover.Header as="h3">{node.workspaceName}</Popover.Header>
              <Popover.Body>
                {this.props.text}
                {node.description ? (
                  <div>
                    <hr></hr> {node.description}
                  </div>
                ) : (
                  ""
                )}
                {node.pbiModifiedDate ? (
                  <div style={{ display: "flex", flexDirectin: "row" }}>
                    <div style={{ paddingRight: "5px" }}>Modified:</div> {moment(node.pbiModifiedDate).format("MM/DD/YY")}
                  </div>
                ) : null}
                {node.pbiCreatedDate ? (
                  <div style={{ display: "flex", flexDirectin: "row" }}>
                    <div style={{ paddingRight: "5px" }}>Created:</div> {moment(node.pbiCreatedDate).format("MM/DD/YY")}
                  </div>
                ) : null}
              </Popover.Body>
            </Popover>
          }>
          <div
            className={`tab ${stateClass} ta-workspace-reports-span reportListFolders topLevelNav nav-item-row`}
            data-testid={reportTestId}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              this.props.clickHandler(this.props, this.props.index, this.props.type);
            }}
            key={this.props.index}>
            <span className="nav-item-icon-slot">{this.itemIcon(this.props.type)}</span>
            <span className="nav-item-label">{this.props.text}</span>
            {canClose && (
              <OverlayTrigger
                key={"closereport-tip"}
                placement={"right"}
                overlay={<Tooltip id={"closereport-tip"}>Close Report</Tooltip>}>
                <div
                  className="close-report-icon"
                  style={{
                    display: "inline",
                    flexShrink: 0,
                    paddingLeft: "13px",
                    cursor: "pointer",
                  }}
                  onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();

                    this.props.removeHandler(event, this.props);
                  }}>
                  <CloseReportIcon height={"15px"} viewBox={"0 0 20 20"} color={"#58595B"} />
                </div>
              </OverlayTrigger>
            )}
          </div>
        </OverlayTrigger>
      );
    }
  }
}
